module.exports = __webpack_public_path__ + "static/media/eps.f8a2e612.svg";